import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { openSnackbar } from '@/core/features/snackbar';
import { closeModal } from '@/core/features/modal';
import i18n from '@/i18n';
import { acceptModal, cancelModal, setDemo } from '../actions';

const acceptModalEpic: Epic = (action$) =>
  action$.pipe(
    filter(acceptModal.match),
    mergeMap(({ payload: { id } }) => [
      closeModal(),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('DEMO_MODAL_ACCEPTED', { id }),
      }),
      setDemo({
        title: i18n.t('ACCEPTED'),
        description: i18n.t('ACCEPTED_WITH_ID', { id }),
      }),
    ]),
  );

const cancelModalEpic: Epic = (action$) =>
  action$.pipe(
    filter(cancelModal.match),
    mergeMap(({ payload: { id } }) => [
      closeModal(),
      openSnackbar({
        snackbarType: 'error',
        snackbarMessage: i18n.t('DEMO_MODAL_CANCELLED', { id }),
      }),
      setDemo({
        title: i18n.t('CANCELLED'),
        description: i18n.t('CANCELLED_WITH_ID', { id }),
      }),
    ]),
  );

export default combineEpics(acceptModalEpic, cancelModalEpic);
